import React, { useState } from 'react'
import { Button, Modal, ModalContent } from '@deal/components'
import styles from './styles.css'

const PhoneExplanationModalMetadata: React.SFC = () => {
  const [isModalOpen, setModalOpen] = useState(false)

  return (
    <>
      <Modal isOpen={isModalOpen} onRequestClose={() => setModalOpen(false)}>
        <ModalContent>
          <div className={styles.header}>Real Experts, Real Advice</div>
          <p className={styles.modalParagraph}>
            When you use Curated, you connect with a real human expert. Your expert will hand pick
            items for you based on your quiz answers. These recommendations are sent over text, so
            it’s easy for you to interact, ask questions, and give feedback.
          </p>{' '}
          <p className={styles.modalParagraph}>
            The expert is there to support <strong>you</strong>. You can connect with them whenever
            and wherever you want. Shop on your terms. If you need more time to consider their
            advice, just let them know.
          </p>{' '}
          <p className={styles.modalParagraph}>
            Don’t worry - your privacy is protected. We use an encrypted number, not your real one.
          </p>
          <p className={styles.modalParagraph}>
            If you prefer to receive your recommendations on Curated.com or via email, you can text
            STOP at any time.
          </p>
          <div className={styles.modalButton}>
            <Button variant="success" onClick={() => setModalOpen(false)}>
              Okay!
            </Button>
          </div>
        </ModalContent>
      </Modal>
      <div className={styles.row}>
        <span className={styles.underline} onClick={() => setModalOpen(true)}>
          Learn more
        </span>{' '}
        about how your expert will contact you.
      </div>
    </>
  )
}

export default PhoneExplanationModalMetadata
